module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#fffff"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "EnderBar"
  }, [_c('h1', [_vm._v("Talk to me on ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto 0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-official",
      "scale": "5"
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('message', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessage),
      expression: "showMessage"
    }],
    staticClass: "tr pop-up-message"
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("This is Header")]), _vm._v(" "), _c('span', {
    slot: "body"
  }, [_vm._v("This is Body")])])], 1), _vm._v(" "), (!_vm.showMessage) ? _c('div', {
    staticClass: "block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMessage = true
      }
    }
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_vm._v("Primary")])]) : (_vm.showMessage) ? _c('div', {
    staticClass: "block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMessage = false
      }
    }
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_vm._v("Primary")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('h1', [_vm._v("WorkTeen Bot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid FirstBar"
  }, [_c('div', {
    staticClass: "col-md-12 row "
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-12 col-xs-12 "
  }, [_c('h1', [_vm._v("\nHey guys\n")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-6 col-xs-10 checkBar",
    staticStyle: {
      "align": "center"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid secondBar"
  }, [_c('div', {
    staticClass: "col-md-12 row "
  }, [_c('div', {
    staticClass: "col-md-5 col-sm-12 col-xs-12 "
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25%"
    }
  }, [_vm._v("\nFeatures\n")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-sm-12 col-xs-12 checkBar2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid thirdBar"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-12 col-xs-12 checkBar3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-12 col-xs-12 "
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25%"
    }
  }, [_vm._v("\nFeatures\n")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01a1538a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bot.vue
// module id = 889
// module chunks = 1